﻿import $ from "jquery";

import { GuiBase } from "../GuiBase";
import { AppLog } from "../AppLog";
import { Chart, ChartConfiguration } from "../chart-setup";
import { IChartData } from "../Interface/IChartData";

export class GuiDashboard extends GuiBase {

    green5 = "#044135";

    constructor() {
        super("Dashboard");

        this.zeichneCharts($(document));
        this.ladeKarten();
    }

    /**
     * Holt den Inhalt aller nachzuladenden Karten (DEVCLR-327). Jede Karte lädt einzeln - eine
     * langsame oder fehlerhafte Karte hält weder die Seite noch die anderen Karten auf.
     * Das HTML kommt fertig vom Server, hier wird nichts zusammengebaut.
     */
    private ladeKarten() {
        $("div[data-karte-url]").each((_index, element) => {
            this.ladeKarte($(element));
        });
    }

    private ladeKarte(divKarte: JQuery<HTMLElement>) {
        const url = divKarte.data("karte-url") as string;
        if (url == undefined || url === "") {
            return;
        }

        AppLog.logInfo("GuiDashboard", `ladeKarte ${url}`);

        $.ajax({
            type: "GET",
            url: url,
            dataType: "html"
        }).done((html: string) => {
            divKarte.html(html);
            // Eine nachgeladene Karte kann eine Grafik enthalten - gezeichnet wird sie mit
            // demselben Code wie bei einer sofort gerenderten Karte.
            this.zeichneCharts(divKarte);
        }).fail(() => {
            AppLog.logError("GuiDashboard", `ladeKarte fehlgeschlagen ${url}`);
            divKarte.html('<p class="card-text text-secondary">Die Daten konnten nicht geladen werden.</p>');
        });
    }

    /**
     * Zeichnet jede Grafik innerhalb des übergebenen Bereichs. Daten und Beschriftung stehen als
     * data-Attribute am Canvas - die Karte bringt alles mit, was sie braucht, deshalb kommt hier
     * keine kartenspezifische Logik mehr dazu.
     */
    private zeichneCharts(bereich: JQuery<HTMLElement> | JQuery<Document>) {
        bereich.find("canvas[data-karte-chart]").each((_index, element) => {
            this.zeichneChart($(element));
        });
    }

    private zeichneChart(canvas: JQuery<HTMLElement>) {
        const daten = canvas.data("karte-chart-daten") as IChartData;
        if (daten == undefined || daten.values == undefined || daten.values.length === 0) {
            return;
        }

        // Einheit (z.B. "€") an y-Achse und Tooltip; Zahlen deutsch formatiert.
        const einheit = (canvas.data("karte-chart-einheit") as string) ?? "";
        const formatiere = (wert: number) => `${wert.toLocaleString("de-DE", { maximumFractionDigits: 0 })}${einheit === "" ? "" : " " + einheit}`;

        const config: ChartConfiguration = {
            type: (canvas.data("karte-chart") as string) === "bar" ? "bar" : "line",
            data: {
                labels: daten.labels,
                datasets: [{
                    label: canvas.data("karte-chart-reihe") as string,
                    data: daten.values,
                    backgroundColor: this.green5,
                    borderColor: this.green5
                }]
            },
            options: {
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            label: (context) => formatiere(context.parsed.y ?? 0)
                        }
                    }
                },
                scales: {
                    y: {
                        ticks: {
                            callback: (wert) => formatiere(Number(wert))
                        }
                    }
                },
                responsive: true,
                maintainAspectRatio: false
            }
        };

        new Chart(canvas[0] as HTMLCanvasElement, config);
    }
}
